// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-category{   
    display: flex;
    justify-content: space-between;
}
.product-details-box{
    margin-top:20px !important;
}
.inner-second-product-box{
    display: flex;
    justify-content: space-between;
}
.add-product-main{
    font-size: 0.7em;
}
.product-sub-box,.sub-inner-m-box{
width:30%;
}

.second-main-product{
    margin-top: 20px;
}
.product-title{
    width: 63%;
}
.add-product-checkbox{
    display: flex;
    justify-content: space-between;
    width:500px;
    margin-top:20px !important;
}
.add-product-checkbox-head{
    font-size: 1.1em !important;
    margin-top:15px !important;
    font-weight: 500;
}

.add-product-head{
    font-size:1.1em !important;
    padding: 10px;
    background-color: whitesmoke !important;
    border-radius: 7px;
    margin-bottom: 20px;
}
.product-main{
    display: flex;
    justify-content: space-between;
}
.add-product-file-box{
margin-top:20px !important;
margin-right: 200px !important;
}
.add-product-file-head{
font-size: 1.1em !important;
font-weight: 500 !important;
}
.add-product-box-main{
    text-align: center;
    border:2px solid rgba(117, 117, 117, 0.308) !important;
    padding: 10px !important;
    cursor: pointer;
}
.add-product-file-attach{
    color:rgb(235,168,90) !important;
    cursor: pointer;
}
.font-size-head{
    font-size: 1em !important;
}
.product-variant-box{
    font-weight: 500;
    margin-top:20px !important;
    margin-bottom: 10px !important;
}
.add-product-list-name{
    display: flex;
    width:99% !important
}
.add-product-stock{
    margin-top:20px !important;
}
.add-product-stock-head{
    font-weight: 500;
    font-size:1.1em;
}
.add-product-inner-stock{
    display: flex;
    width: 36%;
    justify-content: space-around;
    margin-top:10px !important;
}
.add-tag-box{
    width:320px;
    margin-top:20px !important;
}
.add-tag-label{
    font-weight: 500 !important;
    margin-bottom: 10px !important;
}
.add-product-form-cancel{
    color:rgb(235,168,90) !important;
    border: 1px solid rgb(235,168,90) !important;
    padding: 0px 35px 0px 35px !important;
}
.add-product-form-submit{
    background-color: rgb(235,168,90) !important;
    color:white !important;
    padding: 0px 35px 0px 35px !important;
    margin-left: 10px !important;
}
.add-product-form-button{
    float: right;
    margin-bottom:20px !important;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/add-products.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;AACA,SAAS;AACT;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;AACA,0BAA0B;AAC1B,8BAA8B;AAC9B;AACA;AACA,2BAA2B;AAC3B,2BAA2B;AAC3B;AACA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,UAAU;IACV,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;AACA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,qCAAqC;AACzC;AACA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,qCAAqC;IACrC,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC","sourcesContent":[".product-category{   \n    display: flex;\n    justify-content: space-between;\n}\n.product-details-box{\n    margin-top:20px !important;\n}\n.inner-second-product-box{\n    display: flex;\n    justify-content: space-between;\n}\n.add-product-main{\n    font-size: 0.7em;\n}\n.product-sub-box,.sub-inner-m-box{\nwidth:30%;\n}\n\n.second-main-product{\n    margin-top: 20px;\n}\n.product-title{\n    width: 63%;\n}\n.add-product-checkbox{\n    display: flex;\n    justify-content: space-between;\n    width:500px;\n    margin-top:20px !important;\n}\n.add-product-checkbox-head{\n    font-size: 1.1em !important;\n    margin-top:15px !important;\n    font-weight: 500;\n}\n\n.add-product-head{\n    font-size:1.1em !important;\n    padding: 10px;\n    background-color: whitesmoke !important;\n    border-radius: 7px;\n    margin-bottom: 20px;\n}\n.product-main{\n    display: flex;\n    justify-content: space-between;\n}\n.add-product-file-box{\nmargin-top:20px !important;\nmargin-right: 200px !important;\n}\n.add-product-file-head{\nfont-size: 1.1em !important;\nfont-weight: 500 !important;\n}\n.add-product-box-main{\n    text-align: center;\n    border:2px solid rgba(117, 117, 117, 0.308) !important;\n    padding: 10px !important;\n    cursor: pointer;\n}\n.add-product-file-attach{\n    color:rgb(235,168,90) !important;\n    cursor: pointer;\n}\n.font-size-head{\n    font-size: 1em !important;\n}\n.product-variant-box{\n    font-weight: 500;\n    margin-top:20px !important;\n    margin-bottom: 10px !important;\n}\n.add-product-list-name{\n    display: flex;\n    width:99% !important\n}\n.add-product-stock{\n    margin-top:20px !important;\n}\n.add-product-stock-head{\n    font-weight: 500;\n    font-size:1.1em;\n}\n.add-product-inner-stock{\n    display: flex;\n    width: 36%;\n    justify-content: space-around;\n    margin-top:10px !important;\n}\n.add-tag-box{\n    width:320px;\n    margin-top:20px !important;\n}\n.add-tag-label{\n    font-weight: 500 !important;\n    margin-bottom: 10px !important;\n}\n.add-product-form-cancel{\n    color:rgb(235,168,90) !important;\n    border: 1px solid rgb(235,168,90) !important;\n    padding: 0px 35px 0px 35px !important;\n}\n.add-product-form-submit{\n    background-color: rgb(235,168,90) !important;\n    color:white !important;\n    padding: 0px 35px 0px 35px !important;\n    margin-left: 10px !important;\n}\n.add-product-form-button{\n    float: right;\n    margin-bottom:20px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
